import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalToastService {
  message = '';
  show = false;
  type = '';
  delay = 5000;
  private hideToastTimeout: ReturnType<typeof setTimeout> | null = null;

  showToast(msg: any, type: any, delay: number = 5000) {
    if (this.hideToastTimeout) {
      clearTimeout(this.hideToastTimeout);
      this.hideToastTimeout = null;
    }

    this.hideToast();
    this.message = msg;
    this.type = type;
    this.delay = delay;
    this.show = true;

    this.hideToastTimeout = setTimeout(() => this.hideToast(), delay);
  }

  hideToast() {
    this.show = false;
    this.hideToastTimeout = null;
  }
}
